/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
import { Injectable } from '@angular/core';
import { ApiService, FeatureFlag } from '@midas/shared/common';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fetch } from '@nrwl/angular';
import { map, of } from 'rxjs';
import * as FeatureFlagsActions from './feature-flags.actions';

@Injectable()
export class FeatureFlagsEffects {
  readonly getFeatureFlags$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FeatureFlagsActions.getFeatureFlags),
      fetch({
        id: () => true, // Makes `fetch` act like switchMap (cancels previous request)
        run: () =>
          this.api.get<{ count: number; items: FeatureFlag[] }>('/feature-flags').pipe(
            map(({ items, count }) => {
              return FeatureFlagsActions.getFeatureFlagsSuccess({ featureFlags: items, count });
            }),
          ),
        onError: (action, error) => {
          return of(FeatureFlagsActions.getFeatureFlagsError({ error }));
        },
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private api: ApiService,
  ) {}
}
